@if (isLoading()) {
    <div class="boxPlan m-auto flex justify-center items-center">
        <app-loading />
    </div>
}
<div
    class="boxPlan flex flex-col gap-y-3 justify-start"
    data-name="boxPlan">
    @if (!selectSynopticService.isEditMode()) {
        <app-synoptic-plan-header
            [drawerPosition]="drawerPosition()"
            [drawerSize]="drawerSize()"
            [filterOptions]="filterOptions()"
            [planItems]="planItems()"
            [selectedNode]="selectedNode()"
            (close)="closePlan()"
            (enterEdition)="toggleEditMode(true)" />
        <div
            #boxPlanContainer
            class="boxPlan__containers"
            id="boxPlan_container"
            (click)="synopticPlanInteractionService.removeFocusOnFibreAndCables($event)">
            <!-- Dynamic insert content -->
        </div>

        <div
            class="boxPlan__fibre__tooltip"
            id="boxPlan_fibre_tooltip">
            <span id="boxPlan_fibre_tooltip_warning">
                <fa-icon
                    class="text-yellow-500"
                    size="xl"
                    [icon]="['fas', 'triangle-exclamation']" />
                <p>{{ 'synopticPlan.undefinedColor' | transloco }}</p>
            </span>
            <p id="boxPlan_fibre_tooltip_value"></p>
        </div>
    } @else {
        <div class="bg-white !overflow-hidden">
            @if (synopticGraphService.planType() === PlanTypeEnum.BAY) {
                <app-synoptic-bay-plan-edit
                    [depositId]="selectSynopticService.selectedDeposit()!.id"
                    [layerId]="layerId"
                    [selectedNode]="selectedNode()"
                    (leaveEdition)="toggleEditMode(false)" />
            } @else {
                <app-synoptic-plan-edit
                    [depositId]="selectSynopticService.selectedDeposit()!.id"
                    [layerId]="layerId"
                    [selectedNode]="selectedNode()"
                    [type]="synopticGraphService.planType()!"
                    (leaveEdition)="toggleEditMode(false)" />
            }
        </div>
    }
</div>
